<script setup lang="ts">const defaultMessage = __MACROS_toRef(__props, "message");

import { toRef as __MACROS_toRef } from "vue";
import { computed, onMounted } from "vue";
import { useLoadingStore } from "@/stores/loading-store";

withDefaults(defineProps<{ id: string; message?: string; absolute?: boolean }>(), { absolute: true, })
const message = computed(() => useLoadingStore().messages[__props.id] || __props.message);

onMounted(() => {
  useLoadingStore().updateLoadingMessage(__props.id, __props.message ?? "");
});
</script>
<template>
  <div class="tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">
    <div class="tw-z-[2021] tw-max-w-sm tw-flex-col tw-gap-2 tw-text-center" :class="absolute ? 'tw-absolute' : ''">
      <i aria-hidden="true" class="fas fa-circle-notch fa-spin fa-2x" />
      <p v-if="message?.length" class="tw-text-pretty tw-leading-6">
        {{ message }}
      </p>
    </div>
  </div>
</template>
